import * as React from "react"
import { Alert, AlertTitle, Box, Button, Typography } from "@mui/material"

import { PRICE_COLUMN_BY_MODE, PRICING_CONFIG_MODES, ROLE_BY_MODE } from "../@constants"
import { usePricingConfigSave } from "../@hooks"
import { customerSetup, pricingConfigMode } from "../@signals"


/** What is about to be saved, and the button that saves it.
 *
 * It spells out the role change separately from the row changes, because they are not the same kind
 * of thing: one moves a configuration row, the other moves **what every user of the customer sees**.
 */
export default function ManagementPricingConfigSaveBar() {

    const {
        canSave, isSaving, applyRoleChange, pendingCount, handleSave, discardChanges
    } = usePricingConfigSave()

    if (!canSave) return <></>

    const setup = customerSetup.value
    const targetMode = pricingConfigMode.value
    const affectedUsers = targetMode === PRICING_CONFIG_MODES.RETAILER
        ? setup?.standardUsers
        : setup?.retailerUsers

    return <Alert
        severity={applyRoleChange ? 'error' : 'warning'}
        variant="outlined"
        action={<Box display="flex" gap={1} alignItems="center">
            <Button color="inherit" size="small" onClick={discardChanges} disabled={isSaving}>
                Discard
            </Button>
            <Button
                variant="contained"
                color={applyRoleChange ? 'error' : 'primary'}
                size="small"
                onClick={handleSave}
                disabled={isSaving}
            >
                {isSaving ? 'Saving...' : 'Save'}
            </Button>
        </Box>}
    >
        <AlertTitle>Pending changes</AlertTitle>

        <Box component="ul" sx={{ pl: 3, m: 0 }}>
            {!!pendingCount && <li>
                <Typography variant="body2" component="span">
                    {pendingCount} row{pendingCount === 1 ? '' : 's'} added, modified or deleted.
                </Typography>
            </li>}

            {!!applyRoleChange && <li>
                <Typography variant="body2" component="span">
                    <strong>The user type changes</strong>: {affectedUsers} user
                    {affectedUsers === 1 ? '' : 's'} become <code>{ROLE_BY_MODE[targetMode]}</code> and
                    will see <strong>{PRICE_COLUMN_BY_MODE[targetMode]}</strong> from now on.
                </Typography>
            </li>}
        </Box>
    </Alert>
}
